// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"10643151","626":"f1641367"}[chunkId] + ".chunk.js";
};